import styled from 'styled-components';
import { AppRangePicker } from 'components/atoms';

export const RangePickerFilter = styled(AppRangePicker)`
    height: 44px;
`;
